import React, { useState, useEffect, useLayoutEffect, useRef } from 'react'
import axios from "axios";
import StoreToken from "../../components/StoreToken";
import '../VideoView/VideoView.css'
import { defaultQuality, getAuthToken, getLoginPage, globalLoader, catchError } from "../../script/util.js";
import 'video.js/dist/video-js.css';
import VideoPlayer from '../VideoPlayer.js';

const VideoView = () => {
  const [data, setData] = useState()
  const [videoUrl, setVideoUrl] = useState()
  const defQuality = defaultQuality()
  const queryParams = new URLSearchParams(window.location.search);
  const id = queryParams.get("id");
  const { storeToLocal } = StoreToken();
  useLayoutEffect(() => {
    storeToLocal();
  }, []);

  useEffect(()=>{
    var video_url = `${process.env.REACT_APP_STAG_URL}/api/work/portfolio/${id}/`
    axios({
        url: video_url,
        method: "get",
        headers: {
            Authorization: getAuthToken(),
        },
        })
        .then((response) => {
            setData(response.data);
            for(let i = response.data.url_list.length; i>0; i--){
              if(response.data.url_list[i-1].quality===defQuality){
                setVideoUrl(response.data.url_list[i-1].url)
              }
            }
        })
        .catch((error) => {
            catchError(error)
        })
  },[])

    
  return !data ? (
    <div
      className='overlayLoader'
    >
      {globalLoader()}
    </div>
  ) : (
    <>
        <VideoPlayer data={data} id={id} videoUrl={videoUrl} />
    </>
  )
}

export default VideoView